module.exports = __webpack_public_path__ + "01_very_short_black.f299aa71.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_very_short_black.png
// module id = 13iu
// module chunks = 0